var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"game-container flex justify-center"},[_c('div',{staticClass:"game-box",class:{
      mobile: _vm.$device.mobile,
      desktop: !_vm.$device.mobile,
      horizontal: _vm.getSelectedDirection === 'horizontal',
      vertical: _vm.getSelectedDirection === 'vertical',
    }},[_c('img',{staticClass:"background left",attrs:{"src":require("@assets/img/allgame/background-left.png")}}),_c('img',{staticClass:"background right",attrs:{"src":require("@assets/img/allgame/background-right.png")}}),_c('iframe',{ref:"gameFrame",staticClass:"game-iframe",attrs:{"scrolling":"no","id":"iframe","src":`${_vm.process.env.VUE_APP_GAME_URL}/${_vm.getDirection()}/`,"allow":"fullscreen"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }